import { createSlice } from '@reduxjs/toolkit';

import http from '../shared_client_utils/http';

const initialState = {
  isNewClient: null
};

const client = createSlice({
  name: 'clientStatus',
  initialState: initialState,
  reducers: {
    completeLoadClient: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const {
  completeLoadClient,
} = client.actions;

export default client.reducer;

export const loadClientForBooking = (data) => async (dispatch) => {
  const config = {
    data,
  };
  const response = await http.post(
    `${window.baseApiPath}/client/get-already-existing-client`,
    config,
  );

  return dispatch(completeLoadClient(response));
};

export const loadClientForEmailMarketing = (data) => async (dispatch) => {
  const config = {
    data,
  };
  const response = await http.post(
    `${window.baseApiPath}/client/get-client-for-email-marketing`,
    config,
  );

  return dispatch(completeLoadClient(response));
};
